import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
  {
    automationRuleId: 1,
    id: 'LithiumMetalInEquipment',
    label: (
      <FormattedMessage
        defaultMessage='Lithium Metal in Equipment'
        description='otherShippingOptions.dangerType.LithiumMetalInEquipment'
        id='6gziGu'
      />
    ),
  },
  {
    automationRuleId: 2,
    id: 'LithiumMetalPackedWithEquipment',
    label: (
      <FormattedMessage
        defaultMessage='Lithium Metal Packed with Equipment'
        description='otherShippingOptions.dangerType.LithiumMetalPackedWithEquipment'
        id='0Q3NX/'
      />
    ),
  },
  {
    automationRuleId: 3,
    id: 'LithiumMetalStandalone',
    label: (
      <FormattedMessage
        defaultMessage='Lithium Metal Standalone'
        description='otherShippingOptions.dangerType.LithiumMetalStandalone'
        id='21Sg6U'
      />
    ),
  },
  {
    automationRuleId: 4,
    id: 'LithiumIonInEquipment',
    label: (
      <FormattedMessage
        defaultMessage='Lithium Ion in Equipment'
        description='otherShippingOptions.dangerType.LithiumIonInEquipment'
        id='L8dqnq'
      />
    ),
  },
  {
    automationRuleId: 5,
    id: 'LithiumIonPackedWithEquipment',
    label: (
      <FormattedMessage
        defaultMessage='Lithium Ion Packed with Equipment'
        description='otherShippingOptions.dangerType.LithiumIonPackedWithEquipment'
        id='qr0Yp7'
      />
    ),
  },
  {
    automationRuleId: 6,
    id: 'LithiumIonStandalone',
    label: (
      <FormattedMessage
        defaultMessage='Lithium Ion Standalone'
        description='otherShippingOptions.dangerType.LithiumIonStandalone'
        id='uL2U/T'
      />
    ),
  },
  {
    automationRuleId: 7,
    id: 'LithiumIonGroundOnly',
    label: (
      <FormattedMessage
        defaultMessage='Lithium Ion Ground Only'
        description='otherShippingOptions.dangerType.LithiumIonGroundOnly'
        id='hurAnB'
      />
    ),
  },
  { automationRuleId: 8, id: 'ORM_D', label: 'ORM_D' },
  {
    automationRuleId: 9,
    id: 'SmallQuantityProvision',
    label: (
      <FormattedMessage
        defaultMessage='Small Quantity Provision'
        description='otherShippingOptions.dangerType.SmallQuantityProvision'
        id='Dk/pQf'
      />
    ),
  },
  {
    automationRuleId: 10,
    id: 'HazardousMaterials',
    label: (
      <FormattedMessage defaultMessage='Hazardous Materials' description='otherShippingOptions.dangerType.HazardousMaterials' id='yQYPcA' />
    ),
  },
];
